module.exports = __webpack_public_path__ + "img/sisas_logo_transparent.8751e517.png";